// Get cookie to see if discount code applied
const currentCookies = document.cookie;
const cookieParts = currentCookies.split('discount_code=');
const planPickerHeading = document.querySelector('#plan-picker-heading');
const quickShops = document.querySelectorAll('.nutrops-quick-shop');
const announcementBarMessage = document.querySelector('.announcement-bar .announcement-bar__message');
const pdpImageCarousel = document.querySelector('.pdp-image-carousel');
const pdpImageSwiper = pdpImageCarousel?.querySelector('.swiper');
const firstHero = document.querySelector('.nutrops-hero');

let discountCode = null;
if (cookieParts.length === 2) {
    discountCode = cookieParts.pop().split(';').shift();
    let discountMessage = document.createElement('span');
    let discountOff = '0%';
    let discountVal = 0.0;
    if (discountCode == 'FIRST') {
        discountOff = '20%';
        discountVal = 0.20;
    }
    if (discountCode == 'SURPRISE') {
        discountOff = '30%';
        discountVal = 0.30;
    }
    if (discountCode == 'FIRST' || discountCode == 'SURPRISE') {

        // PDP
        discountMessage.className = "discount-code-applied bg-lt-purple text-[10px] tracking-[0.01em] leading-[10px] uppercase py-2 px-4 rounded-[30px]";
        discountMessage.innerHTML = `<strong>Save ${discountOff}! Discount applied at checkout</strong>`;
        // add message to Plan Picker Heading
        // planPickerHeading?.appendChild(discountMessage);
        const discountBannerFirst = document.querySelector('#discount_banner_first');
        const discountBannerSurprise = document.querySelector('#discount_banner_surprise');
        if (discountBannerFirst || discountBannerSurprise) {
            if (discountCode == 'FIRST') {
                // Only display if content is entered
                if (discountBannerFirst.innerHTML.length > 17) {
                    discountBannerFirst.classList.remove('hidden');
                }
            }
            if (discountCode == 'SURPRISE') {
                // Only display if content is entered
                if (discountBannerSurprise.innerHTML.length > 17) {
                    discountBannerSurprise.classList.remove('hidden');
                }
            }
        }
        // add message to PDP Image Carousel
        if (pdpImageCarousel && pdpImageSwiper) {
            const carouselBubbleFIRST = pdpImageCarousel.querySelector('#carousel-bubble-first');
            const carouselBubbleSURPRISE = pdpImageCarousel.querySelector('#carousel-bubble-surprise');
            if (discountCode == 'FIRST') {
                // Only display if content is entered
                if (carouselBubbleFIRST.innerHTML.length > 17) {
                    carouselBubbleFIRST.classList.remove('hidden');
                }
            }
            if (discountCode == 'SURPRISE') {
                // Only display if content is entered
                if (carouselBubbleSURPRISE.innerHTML.length > 17) {
                    carouselBubbleSURPRISE.classList.remove('hidden');
                }
            }
        }

        // Quick Shop
        quickShops?.forEach((quickShop) => {
            const quickShopATCs = quickShop.querySelectorAll('.quick-shop-atc');
            quickShopATCs?.forEach((quickShopATC) => {
                const parentDiv = quickShopATC.parentNode;
                // add discount message
                const discountMessageClone = discountMessage.cloneNode(true);
                discountMessageClone.classList.add("inline-block", "mb-4");
                parentDiv.insertBefore(discountMessageClone, quickShopATC);
                // update price
                const variantPriceSpan = parentDiv.querySelector('.variant-price');
                const variantPrice = variantPriceSpan.dataset.price;
                const discountedPrice = Math.ceil(variantPrice *  (1 - discountVal)) / 100;
                variantPriceSpan.innerHTML = discountedPrice.toFixed(2);
            });
        });

        // Announcement Bar
        // Only swap the message when the section actually provides an override —
        // otherwise leave the server-rendered message untouched.
        if (announcementBarMessage) {
            const msgDesktop = announcementBarMessage.querySelector('.msg');
            const msgMobile = announcementBarMessage.querySelector('.msg-mobile');
            if (discountCode == 'FIRST') {
                if (msgDesktop && announcementBarMessage.dataset.msgfirst) {
                    msgDesktop.innerHTML = announcementBarMessage.dataset.msgfirst;
                }   
                if (msgMobile && announcementBarMessage.dataset.msgfirstmobile) {
                    msgMobile.innerHTML = announcementBarMessage.dataset.msgfirstmobile;
                }   
            }   
            if (discountCode == 'SURPRISE') {
                if (msgDesktop && announcementBarMessage.dataset.msgsurprise) {
                    msgDesktop.innerHTML = announcementBarMessage.dataset.msgsurprise;
                }   
                if (msgMobile && announcementBarMessage.dataset.msgsurprisemobile) {
                    msgMobile.innerHTML = announcementBarMessage.dataset.msgsurprisemobile;
                }
            }
        }

        // Hero
        if (firstHero) {
            const bgImgs = firstHero.querySelector('.bg-imgs');
            const heroHeading = firstHero.querySelector('h1');
            const discountImgFirst = bgImgs.dataset.imgfirst;
            const discountImgFirstMobile = bgImgs.dataset.imgfirstmobile;
            const discountImgSurprise = bgImgs.dataset.imgsurprise;
            const discountImgSurpriseMobile = bgImgs.dataset.imgsurprisemobile;
            const imgDesktop = bgImgs.querySelector('.hero-img');
            const imgMobile = bgImgs.querySelector('.hero-img-mobile');
            let discount_img_DOM = null;
            let discount_img_mobile_DOM = null;

            if (discountCode == 'FIRST') {
                discount_img_DOM = ` 
                    <picture>
                        <source media="(min-width: 993px)" srcset="${ discountImgFirst }&width=1000 1000w, ${ discountImgFirst }&width=1200 1200w, ${ discountImgFirst }&width=1400 1400w, ${ discountImgFirst }&width=1600 1600w, ${ discountImgFirst }&width=1800 1800w" sizes="100vw">
                        <source media="(max-width: 992px)" srcset="${ discountImgFirst }&width=200 200w, ${ discountImgFirst }&width=400 400w, ${ discountImgFirst }&width=600 600w, ${ discountImgFirst }&width=800 800w," sizes="100vw">
                        <img alt="" width="1920" height="1039" src="${ discountImgFirst }&width=1920">
                    </picture>
                `;
                discount_img_mobile_DOM = ` 
                    <picture>
                        <source srcset="${ discountImgFirstMobile }&width=200 200w, ${ discountImgFirstMobile }&width=400 400w, ${ discountImgFirstMobile }&width=600 600w" sizes="100vw">
                        <img alt="" width="1010" height="987" src="${ discountImgFirstMobile }&width=768">
                    </picture>
                `;
                // Only update if content entered
                if (heroHeading.dataset.headingfirst.length > 0) {
                    heroHeading.innerHTML = heroHeading.dataset.headingfirst;
                }
            }
            if (discountCode == 'SURPRISE') {
                discount_img_DOM = ` 
                    <picture>
                        <source media="(min-width: 993px)" srcset="${ discountImgSurprise }&width=1000 1000w, ${ discountImgSurprise }&width=1200 1200w, ${ discountImgSurprise }&width=1400 1400w, ${ discountImgSurprise }&width=1600 1600w, ${ discountImgSurprise }&width=1800 1800w" sizes="100vw">
                        <source media="(max-width: 992px)" srcset="${ discountImgSurprise }&width=200 200w, ${ discountImgSurprise }&width=400 400w, ${ discountImgSurprise }&width=600 600w, ${ discountImgSurprise }&width=800 800w," sizes="100vw">
                        <img alt="" width="1920" height="1039" src="${ discountImgSurprise }&width=1920">
                    </picture>
                `;
                discount_img_mobile_DOM = ` 
                    <picture>
                        <source srcset="${ discountImgSurpriseMobile }&width=200 200w, ${ discountImgSurpriseMobile }&width=400 400w, ${ discountImgSurpriseMobile }&width=600 600w" sizes="100vw">
                        <img alt="" width="1010" height="987" src="${ discountImgSurpriseMobile }&width=768">
                    </picture>
                `;
                // Only update if content entered
                if (heroHeading.dataset.headingsurprise.length > 0) {
                    heroHeading.innerHTML = heroHeading.dataset.headingsurprise;
                }
            }
            imgDesktop.innerHTML = discount_img_DOM;
            imgMobile.innerHTML = discount_img_mobile_DOM;
        };
    }
}